import { useState } from "react"
import { StringListSerializer, useSyncPubSub } from "../../../hooks/use-sync-pub-sub"
import { IFCViewerV4ConfigOptions } from "./config"
import { getEncodedPathName, toAbsoluteUrl } from "./urls"

type GhostedSubscriptionConf = {
  widgetId: string
  subscription: string | null | undefined
  multipleselectparametertype: IFCViewerV4ConfigOptions["multipleselectparametertype"]
}

/**
 * Session-local ghosting, owned by whichever widget publishes the topic
 * (a Tree++ with checkboxes, for instance). Nothing is written to the triplestore.
 *
 * Returns undefined when no subscription is configured, so the caller falls back
 * to the ghosting from {@link useGhostedModels}. With a subscription configured the
 * topic is authoritative, and an empty list legitimately means nothing is ghosted.
 */
export function useGhostedSubscription(conf: GhostedSubscriptionConf): ReadonlySet<string> | undefined {
  const [ ghostedUrls, setGhostedUrls ] = useState<ReadonlySet<string>>(new Set())

  useSyncPubSub({
    enabled: Boolean(conf.subscription),
    sourceId: conf.widgetId,
    serializer: new StringListSerializer(conf.multipleselectparametertype),
    subscribe: {
      topic: conf.subscription,
      // Normalized the same way as the model URLs, since those become the modelIds
      handleValue: urls => setGhostedUrls(new Set(urls.map(url => toAbsoluteUrl(getEncodedPathName(url))))),
    },
  })

  if (!conf.subscription) return undefined
  return ghostedUrls
}
